import { OrderRow } from './parseOrders';

function getToken(): string {
  return sessionStorage.getItem('admin-token') || '';
}

function authHeaders(): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getToken()}`,
  };
}

export async function saveOrders(rows: OrderRow[], headers: string[]): Promise<number> {
  if (headers.length > 0) {
    localStorage.setItem('order-headers', JSON.stringify(headers));
  }

  // 500건씩 배치로 전송
  let saved = 0;
  const BATCH = 500;
  for (let i = 0; i < rows.length; i += BATCH) {
    const batch = rows.slice(i, i + BATCH);
    const resp = await fetch('/api/orders', {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ rows: batch }),
    });

    if (!resp.ok) {
      console.error('Save batch error:', await resp.text());
      continue; // 실패해도 다음 배치 계속 진행
    }
    const data = await resp.json();
    saved += data.saved;
  }
  return saved;
}

export async function getHeaders(): Promise<string[]> {
  const stored = localStorage.getItem('order-headers');
  return stored ? JSON.parse(stored) : [];
}

export async function getOrderCount(): Promise<number> {
  const resp = await fetch('/api/orders/count', { headers: authHeaders() });
  if (!resp.ok) return 0;
  const data = await resp.json();
  return data.count;
}

export async function loadRecentOrders(limit: number): Promise<OrderRow[]> {
  const resp = await fetch(`/api/orders/recent?limit=${limit}`, { headers: authHeaders() });
  if (!resp.ok) return [];
  return resp.json();
}

export async function searchOrders(term: string, limit: number = 200): Promise<OrderRow[]> {
  const resp = await fetch(
    `/api/orders/search?term=${encodeURIComponent(term)}&limit=${limit}`,
    { headers: authHeaders() }
  );
  if (!resp.ok) return [];
  return resp.json();
}

export async function clearAllOrders(): Promise<void> {
  await fetch('/api/orders', { method: 'DELETE', headers: authHeaders() });
  localStorage.removeItem('order-headers');
}
